import { MenuOnSession } from '@/services/auth/menu.types'
import { Utils } from '@/utils/Utils'
import { isArray } from 'lodash-es'
import { queryClient } from '@/utils/queryClient'

export class MenuOnSessionWrap {
  name = ''

  constructor(name: string) {
    this.name = name
  }

  getCurrentMenu = () => {
    const menus = this.get()
    const curCode = window.location.pathname.match(/\/([a-zA-Z\d]*)$/i)?.[1] ?? ''
    return menus.find((item) => item.code === curCode)
  }

  get = () => {
    let list: MenuOnSession[] = []

    try {
      const curMenuOnSession = sessionStorage.getItem(this.name) || ''
      if (curMenuOnSession) list = JSON.parse(curMenuOnSession) || []
    } catch (e) {
      // ERROR
      // console.dir(e)
    }

    return isArray(list) ? list : []
  }

  getMenuWithCode = (code: string) => {
    const menus = this.get()
    return menus.find((item) => item.code === code)
  }

  add = ({ code, name, link }: MenuOnSession) => {
    const list = this.get()
    if (!list.find((menu) => menu.code === code)) {
      list.push({ code, name, link })
      sessionStorage.setItem(this.name, JSON.stringify(list))
    }
  }

  setSearch = (query: Object) => {
    const list = this.get()
    const currentMenu = this.getCurrentMenu()
    const target = list.find((item) => item.code === currentMenu?.code)
    if (target) {
      target.search = Utils.qsStringify(query ?? '')
      sessionStorage.setItem(this.name, JSON.stringify(list))
    }
  }

  // NOTE: 상세 화면 저장 시 사용
  // const { reload } = useMenuOnSession()
  // 저장 후 reload 해주어야 정상 작동합니다.
  setLinkSearch = ({ menuCode, query, link }: { menuCode: string; query?: Object; link?: string }) => {
    const menus = this.get()
    const updateMenuList = menus.map((menu) => {
      if (menu.code === menuCode) {
        return { ...menu, link: link ?? menu.link, search: Utils.qsStringify(query ?? '') }
      }
      return menu
    })
    sessionStorage.setItem(this.name, JSON.stringify(updateMenuList))
  }

  // 현재 탭의 search와 tabSearches를 함께 업데이트
  setTabSearch = (tabKey: string, query: Object) => {
    const list = this.get()
    const currentMenu = this.getCurrentMenu()
    const target = list.find((item) => item.code === currentMenu?.code)
    if (target) {
      const searchString = Utils.qsStringify({ ...query, tabType: tabKey })

      // 현재 탭 상태로 search 업데이트 (tabType 포함한 전체 쿼리)
      const searchWithTab = Utils.qsStringify({ ...query, tabType: tabKey })
      target.search = searchWithTab

      // tabSearches 배열에서 해당 tabKey 찾아서 업데이트 또는 추가
      if (!target.tabSearches) {
        target.tabSearches = []
      }

      const existingIndex = target.tabSearches.findIndex((item) => item.tabKey === tabKey)
      if (existingIndex >= 0) {
        target.tabSearches[existingIndex].search = searchString
      } else {
        target.tabSearches.push({ tabKey, search: searchString })
      }

      sessionStorage.setItem(this.name, JSON.stringify(list))
    }
  }

  // 특정 tabKey의 tabSearch 조회
  getTabSearch = (tabKey: string) => {
    const currentMenu = this.getCurrentMenu()
    const tabSearch = currentMenu?.tabSearches?.find((item) => item.tabKey === tabKey)
    return tabSearch?.search || ''
  }

  remove = (code: string) => {
    const list = this.get()
    const idxToRemove = list.findIndex((menu) => menu.code === code)
    const menuToRemove = list.splice(idxToRemove, 1)?.[0]

    // 탭 삭제 시 관련 쿼리 데이터도 삭제, 사용 시 쿼리 키에 메뉴 코드가 포함되어야 함
    queryClient.getQueriesData({}).forEach(([queryKey]) => {
      if (Array.isArray(queryKey) && queryKey.some((key) => typeof key === 'string' && key.includes(code))) {
        queryClient.removeQueries({ queryKey })
      }
    })

    sessionStorage.setItem(this.name, JSON.stringify(list))

    return [menuToRemove, idxToRemove] as const
  }

  clear = () => {
    sessionStorage.removeItem(this.name)
  }
}
